import { useState } from "react";

const FIUBenefits = () => {
  const [activeTab, setActiveTab] = useState("ben-one");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      <div className="row fiu-benefits-row">
        <div className="col-lg-6">
          <ul className="fiu-benefits-lists">
            <li
              className={`${activeTab === "ben-one" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-one")}
            >
              <div className="ben-content-flex">
                Expertise and Knowledge{" "}
                <span
                  className={`ben-arr ${activeTab === "ben-one" ? "show" : ""}`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
            <li
              className={`${activeTab === "ben-two" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-two")}
            >
              <div className="ben-content-flex">
                Time and Cost Efficiency{" "}
                <span
                  className={`ben-arr ${activeTab === "ben-two" ? "show" : ""}`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
            <li
              className={`${activeTab === "ben-three" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-three")}
            >
              <div className="ben-content-flex">
                Reduced Risk of Non-Compliance{" "}
                <span
                  className={`ben-arr ${
                    activeTab === "ben-three" ? "show" : ""
                  }`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
            <li
              className={`${activeTab === "ben-four" ? "active" : ""}`}
              onClick={() => handleTabClick("ben-four")}
            >
              <div className="ben-content-flex">
                Tailored Solutions
                <span
                  className={`ben-arr ${
                    activeTab === "ben-four" ? "show" : ""
                  }`}
                >
                  <i className="fa-solid fa-angle-right"></i>
                </span>
              </div>
            </li>
          </ul>
        </div>
        <div className="col-lg-6">
          <div className="fiu-benefits-right">
            <img
              src={require(`../../../image/fiu/benefits-img-oneNew.webp`)}
              alt="FIU Consultant"
              className={`ben-img fiuConsImgMain ${activeTab === "ben-one" ? "show" : ""}`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-one" ? "show" : ""
              }`}
            >
              FIU consultants have in-depth knowledge of AML and CTF
              regulations, ensuring your business meets all legal requirements.
            </p>
            <img
              src={require(`../../../image/fiu/benefits-img-twoNew.webp`)}
              alt="FIU Consultant"
              className={`ben-img fiuConsImgMain ${activeTab === "ben-two" ? "show" : ""}`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-two" ? "show" : ""
              }`}
            >
              By streamlining the application process, consultants save your
              business valuable time and resources.
            </p>
            <img
              src={require(`../../../image/fiu/benefits-img-threeNew.webp`)}
              alt="FIU Consultant"
              className={`ben-img fiuConsImgMain ${activeTab === "ben-three" ? "show" : ""}`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-three" ? "show" : ""
              }`}
            >
              Non-compliance can lead to heavy penalties and reputational
              damage. Consultants help mitigate this risk.
            </p>
            <img
              src={require(`../../../image/fiu/benefits-img-fourNew.webp`)}
              alt="FIU Consultant"
              className={`ben-img fiuConsImgMain ${activeTab === "ben-four" ? "show" : ""}`}
            />
            <p
              className={`fiu-benefits-right-content ${
                activeTab === "ben-four" ? "show" : ""
              }`}
            >
              Every business is unique, and consultants provide customized
              solutions that align with your specific needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FIUBenefits;
